import React, { useState } from "react";
import './CareersFaqs.css';
import q from "../assets/images/faqs.png";

const CareersFaqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What types of positions do you typically hire for?",
      answer:
        "We hire across all our service areas including Financial Services (Tax, Accounting, Payroll), Digital Solutions (Web Development, AI Chatbots), Marketing & Branding, Legal & Compliance, Business Growth, and HR & Operations. Positions range from entry-level to senior roles in both India and the US.",
    },
    {
      question: "Are all positions remote?",
      answer:
        "Yes, all our positions are fully remote. We have team members working from various locations in India and the US. We provide the necessary tools and infrastructure to support effective remote collaboration.",
    },
    {
      question: "What experience levels do you hire for?",
      answer:
        "We hire at all experience levels - from fresh graduates (0-1 years) to senior professionals (5+ years). Many of our positions are available for 1.5, 2.5, and 3.5 years of experience as well, providing growth opportunities at every career stage.",
    },
    {
      question: "What is the hiring process like?",
      answer:
        "Our process typically includes: 1) Resume screening, 2) Initial HR call, 3) Technical/role-specific assessment, 4) Interview with team leads, and 5) Final discussion with leadership. The entire process usually takes 2-3 weeks.",
    },
    {
      question: "Do you provide training for new hires?",
      answer:
        "Yes, we have a comprehensive onboarding program that includes company orientation, role-specific training, and mentorship. For technical roles, we provide hands-on training with our tools and systems.",
    },
    {
      question: "What benefits do you offer?",
      answer:
        "We offer competitive salaries, performance bonuses, health insurance, flexible work hours, learning & development stipends, wellness programs, and paid time off. Specific benefits may vary by location.",
    },
    {
      question: "How does performance evaluation work?",
      answer:
        "We conduct quarterly performance reviews with 360° feedback. Evaluations are based on goal achievement, skill development, and cultural alignment. Top performers are eligible for promotions and bonuses.",
    },
    {
      question: "What growth opportunities are available?",
      answer:
        "We prioritize internal mobility with clear career paths in each department. Employees can grow vertically into leadership roles or horizontally across different functions through our cross-training programs.",
    },
    {
      question: "What's the work culture like at Krinvy?",
      answer:
        "We foster a culture of innovation, collaboration, and ownership. Our values include excellence, integrity, and continuous learning. We maintain open communication and encourage creative problem-solving.",
    },
    {
      question: "Do you hire international candidates?",
      answer:
        "Yes, we hire talent globally for certain positions, particularly in our digital solutions and consulting teams. However, some roles may require specific regional expertise or certifications.",
    },
    {
      question: "What technical skills are most valued?",
      answer:
        "For technical roles, we value expertise in React/Node.js, Python, cloud platforms (AWS/GCP), and AI/ML. For finance roles, proficiency in QuickBooks, Tally, Drake, or other industry software is preferred.",
    },
    {
      question: "How often do you recruit?",
      answer:
        "We have ongoing recruitment for most roles. Peak hiring periods are typically January-March (post-budget) and July-September (mid-year expansion). Some specialized roles may have specific hiring cycles.",
    },
    {
      question: "Do you offer internships?",
      answer:
        "Yes, we offer paid internships across departments including Development, Marketing, Finance, and HR. Internships typically last 3-6 months with potential for full-time conversion.",
    },
    {
      question: "What's the typical career progression?",
      answer:
        "Example progression in Development: Junior Developer (0-1.5 yrs) → Developer (1.5-3 yrs) → Senior Developer (3-5 yrs) → Tech Lead (5+ yrs). Similar paths exist in other departments with clear milestones.",
    },
    {
      question: "How diverse is your team?",
      answer:
        "We're proud of our diverse team spanning different genders, backgrounds, and locations. About 40% of our leadership team identifies as female, and we have team members from 15+ Indian states and multiple US states.",
    },
    {
      question: "What's your approach to work-life balance?",
      answer:
        "We encourage sustainable productivity with flexible schedules, no-meeting blocks, and mandatory time-off policies. Our core collaboration hours are 10AM-3PM IST with flexibility outside this window.",
    },
    {
      question: "Do you sponsor certifications?",
      answer:
        "Yes, we sponsor relevant certifications like CPA, AWS, Google Ads, HubSpot, and others based on role requirements and employee development plans.",
    },
    {
      question: "What's the best way to apply?",
      answer:
        "Submit your application through our careers portal with an updated resume and cover letter. Tailor your application to highlight relevant experience for the specific role you're applying for.",
    },
    {
      question: "How long does the recruitment process take?",
      answer:
        "Typically 2-3 weeks from application to offer. Some senior roles may take longer due to additional interview rounds. We strive to keep candidates informed at each stage.",
    },
    {
      question: "What qualities do you look for in candidates?",
      answer:
        "Beyond technical skills, we value problem-solving ability, adaptability, communication skills, and cultural fit. We look for self-starters who thrive in remote environments.",
    },
    {
      question: "Do you conduct background checks?",
      answer:
        "Yes, we conduct professional background verification for all hires, including employment history and education verification, as part of our standard onboarding process.",
    },
    {
      question: "Can I apply for multiple positions?",
      answer:
        "Yes, you may apply for up to 3 positions simultaneously if you meet the qualifications. We recommend prioritizing roles that best match your skills and interests.",
    },
    {
      question: "What's your policy on remote work equipment?",
      answer:
        "We provide a one-time stipend to set up your home office (laptop, peripherals, etc.) along with necessary software licenses. High-speed internet reimbursement is also available.",
    },
    {
      question: "How does team collaboration work remotely?",
      answer:
        "We use Slack for communication, Zoom for meetings, Notion for documentation, and GitHub/Jira for technical collaboration. Regular team syncs and virtual socials keep everyone connected.",
    },
  ];

  return (
    <div className="careers-faqs-container">
      <div className="careers-faqs-header">
        <h2 className="careers-faqs-heading">Got Questions?</h2>
        <h3 className="careers-faqs-subheading">Everything you need to know about working at Krinvy.</h3>
      
      </div>

      <div className="careers-faqs-accordion">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`careers-faqs-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button 
              className="careers-faqs-question"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeIndex === index}
            >
              <h3>{faq.question}</h3>
              <span className="careers-faqs-icon">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div className="careers-faqs-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareersFaqs;